var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ClassifierService/addNode.ts";
import { setNode } from "./setNode";
export var addNode = function addNode(nodes, node) {
  return setNode(nodes, node.id, function () {
    return node;
  });
};